<template>
    <el-breadcrumb class="breadcrumb" separator="/">
        <transition-group name="breadcrumb">
            <el-breadcrumb-item v-for="item in breadcrumbData" :key="item.path">
                <span class="no-redirect">{{ item.meta?.title }}</span>
            </el-breadcrumb-item>
        </transition-group>
    </el-breadcrumb>
</template>

<script setup>
import { ref, watch } from 'vue'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'
import { getModuleOptionLists } from '@/api/module'

const route = useRoute()
const store = useStore()

const moduleList = ref([])
const firetLevel = ref({})

// 生成数组数据
const breadcrumbData = ref([])
const getBreadcrumbData = () => {
    firetLevel.value = {
        path: '',
        meta: {
            title: moduleList.value.find((ele) => ele.id === store.getters.subsystem).name
        }
    }
    breadcrumbData.value = [firetLevel.value, ...route.matched.filter((item) => item.meta && item.meta.title)]
}

// 监听路由变化时触发
watch(
    route,
    async () => {
        if (!moduleList.value.length) {
            moduleList.value = await getModuleOptionLists()
        }
        getBreadcrumbData()
    },
    {
        immediate: true
    }
)
</script>

<style lang="scss" scoped>
.breadcrumb {
    font-size: 14px;
    padding: 10px 20px;
    border-radius: 15px;
    background-color: rgba(255, 255, 255, 0.5);

    // margin-left: 8px;
    // padding: 0 20px;
    .redirect {
        color: #666;
        font-weight: 600;
    }

    :deep(.no-redirect) {
        color: #97a8be;
        cursor: text;
    }
}
</style>
